import React from 'react';
import { Card, withStyles, } from '@material-ui/core';
import axios from '../../../../utils/AxiosWrapper';
import 'react-toastify/dist/ReactToastify.css';
import { styles } from '../InfoStyles';

export class InfoPrecipitation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: 1
        };
    };

    componentDidMount() {
        axios.get('api/map/language')
            .then(res => {
                let response = res.data.data[0].id_jezik;
                if (response) this.setState({ language: response });
            })
            .catch(err => { console.log(err) })
    };

    render() {
        const { classes } = this.props;
        return (
            <div>
                {this.state.language === 1 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Padavine, posebno kiša, u velikoj meri utiču na poljoprivredu. Svim biljkama je potrebna voda da prežive, stoga je kiša, kao najefikasnije sredstvo za zalivanje, važna za poljoprivredu. Previše ili premalo vode može biti štetno za biljke, suše povećava eroziju a preterano vlažno vreme dovodi do pojave bolesti.
                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 2 &&
                    <Card className={classes.margin}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Precipitation, especially rain, greatly affects agriculture. All plants need water to survive, so rain, as the most effective means of watering,  is important for agriculture. Too much or too little water can be harmful to plants, drought increase erosion and excessively wet weather lead to diseases.
                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 4 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Oborine, posebno kiša, uvelike utječu na poljoprivredu. Svim biljkama je potrebna voda za preživljavanje, pa je kiša, kao najučinkovitije sredstvo zalijevanja, važna za poljoprivredu. Previše ili premalo vode može biti štetno za biljke, suša povećava eroziju, a pretjerano vlažno vrijeme dovodi do bolesti.
                            </p>
                        </div>
                    </Card>
                }
                {this.state.language === 5 &&
                    <Card className={classes.margin} style={{ marginTop: 30 }}>
                        <div className={classes.margin}>
                            <p className={classes.paragraph}>
                                Padavine, zlasti dež, močno vplivajo na kmetijstvo. Vse rastline potrebujejo vodo za preživetje, dež pa je kot najučinkovitejše sredstvo namakanja pomemben za kmetijstvo. Preveč ali premalo vode je lahko škodljivo za rastline, suša povečuje erozijo, pretirano mokro vreme pa vodi do bolezni.
                            </p>
                        </div>
                    </Card>
                }
            </div>
        )
    };
};

export default withStyles(styles)(InfoPrecipitation);